import { useParams, Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/data';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { useEffect, useState } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'guide');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug) || categories[0];
  const categoryArticles = articles.filter((a) => a.category === activeSlug);

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory.name} - 91叔叔`,
    description: currentCategory.description,
    url: `https://www.91uncle.com/category/${activeSlug}`,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <Breadcrumb
        items={[
          { label: '首页', to: '/' },
          { label: currentCategory.name },
        ]}
      />

      <section className="w-full px-4 md:px-6 py-10 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              {currentCategory.name}
            </h1>
            <p className="text-foreground-500 text-sm md:text-base">
              {currentCategory.description}
            </p>
          </div>

          <div className="flex gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:scale-[1.02]"
                >
                  <div className="relative w-full h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={`${article.title} - 91叔叔`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs text-foreground-400">{article.date}</span>
                      <span className="text-xs text-foreground-400">{article.readTime}</span>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 bg-background-100 rounded-full flex items-center justify-center">
                <i className="ri-inbox-line text-2xl text-foreground-300"></i>
              </div>
              <p className="text-foreground-400 text-sm">该分类暂无内容，敬请期待</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}